export default __webpack_public_path__ + "static/media/shop-categories-img01.8a0f363e.jpg";